// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarVisualizacaoCarteira,
  getVisualizacaoCarteiraSelecionada,
  getVisualizacoesCarteira,
} from "../../../../state";

export default function SelecaoVisualizacaoCarteira() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"configuracaoRelatorio.visualizacao.carteira"}
        itensSelector={getVisualizacoesCarteira}
        selectorItemSelecionado={getVisualizacaoCarteiraSelecionada}
        onItemChange={selecionarVisualizacaoCarteira}
        campoId="id"
        campoChaveTraducao="chaveTraducao"
      />
    </div>
  );
}
